import { ClientModel } from 'api/dto/Client.dto';
import { PaginationModel } from 'model/Pagination.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'client';

export namespace ClientState {
  export type Domain = {
    listResource: Resource<ClientModel[]>;
    listPagination: PaginationModel | null;
  };

  export const INITIAL_DOMAIN: Domain = {
    listResource: Resource.createPendingResource(),
    listPagination: null,
  };
}
